var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2383 7.57374V2.79789C15.2383 2.35723 14.8811 2 14.4404 2H5.81474C5.60312 2 5.40018 2.08406 5.25055 2.23369L2.23435 5.24989C2.08472 5.39952 2.00066 5.60247 2.00066 5.81408V17.9246C2.00066 18.3648 2.35708 18.7218 2.79723 18.7225L14.4391 18.7417C14.8803 18.7424 15.2383 18.385 15.2383 17.9438V15.9343",
    stroke: "black",
    strokeWidth: 1.2594,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16016 9.10352H4.97985",
    stroke: "black",
    strokeWidth: 1.2594,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16016 6.31641H6.37329",
    stroke: "black",
    strokeWidth: 1.2594,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9609 11.4155L14.6401 13.0947L17.9985 9.73633",
    stroke: "#0B0B0B",
    strokeWidth: 1.2594,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/ReportIcon.24e94e452f83792a9633f9fd6fabcaeb.svg";
export { ForwardRef as ReactComponent };